import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { ToggleButton } from "primereact/togglebutton";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { MainContext } from "../../Contexts/MainContext";
import "./payment.css";
import { InputMask } from "primereact/inputmask";

function validarCPF(cpf) {
  // Remove caracteres não numéricos
  cpf = cpf.replace(/[^\d]+/g, "");

  // Verifica se tem 11 dígitos
  if (cpf.length !== 11) return false;

  // Elimina CPFs inválidos conhecidos (todos dígitos iguais)
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  // Valida primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digito1 = resto > 9 ? 0 : resto;
  if (digito1 !== parseInt(cpf.charAt(9))) return false;

  // Valida segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  let digito2 = resto > 9 ? 0 : resto;
  if (digito2 !== parseInt(cpf.charAt(10))) return false;

  return true;
}

export const Payment = ({ config }) => {
  const { payment, setPayment, opt } = useContext(MainContext);
  const [troco, setTroco] = useState(false);
  const [value, setValue] = useState();
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState(false);
  const [cpf, setCpf] = useState("");
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [tStyle, setTStyle] = useState({
    backgroundColor: "green",
    color: "white",
  });

  useEffect(() => {
    if (troco) {
      setTStyle({ backgroundColor: "green", color: "white" });
    } else {
      setTStyle({ backgroundColor: "red", color: "white" });
    }

    const _payments = [];

    if (!opt.semdinheiro) {
      _payments.push({ label: "Dinheiro", value: "Dinheiro" });
    }

    if (!opt.semcartao) {
      if (opt.cartaoduplo) {
        _payments.push({ label: "Cartão Crédito", value: "Cartao Credito" });
        _payments.push({ label: "Cartão Débito", value: "Cartao Debito" });
      } else {
        _payments.push({ label: "Cartão", value: "Cartao" });
      }
    }

    if (opt.pix) {
      _payments.push({ label: "PIX", value: "PIX" });
    }

    setPaymentTypes(_payments);
  }, [opt.pix, troco, opt.cartaoduplo, opt.semdinheiro, opt.semcartao]);

  const cartListStyle = {
    backgroundColor: "orange",
    color: config.theme.fontColor,
    padding: "10px",
    marginLeft: "0.5rem",
    marginRight: "0.5rem",
    marginTop: "0.5rem",
    marginBottom: "2rem",
    borderRadius: "10px",
    flex: 1,
  };

  function onChangeCPF(e) {
    setCpf(e.target.value);

    if (validarCPF(e.target.value)) {
      setPayment({ ...payment, cpf: e.target.value });
    } else {
      setPayment({ ...payment, cpf: null });
    }
  }

  const footer = (
    <div className="p-grid p-dir-col" style={{ padding: "5px" }}>
      <Button
        className="p-col"
        style={{ marginBottom: "5px", background: "green", color: "white" }}
        label="Confirmar"
        onClick={onConfirm}
      />
      <Button
        className="p-col"
        style={{ background: "red", color: "white" }}
        label="Não Preciso"
        onClick={onCancel}
      />
    </div>
  );

  function onHide() {
    setVisible(false);
  }

  function onConfirm() {
    if (!value || parseFloat(value) === 0) {
      setError(true);
    } else {
      setPayment({ ...payment, value: value });
      setTroco(true);
      setVisible(false);
    }
  }

  function onCancel() {
    setPayment({ ...payment, value: 0 });
    setVisible(false);
    setTroco(false);
  }

  function onToggle(e) {
    setVisible(true);
  }

  return (
    <div className="p-grid p-dir-col p-shadow-9" style={cartListStyle}>
      <Dialog
        header="Troco para:"
        footer={footer}
        visible={visible}
        style={{
          width: "60%",
          backgroundColor: "orange",
          borderRadius: "20px",
          filter: "drop-shadow(2px 4px 6px black)",
          border: "1px solid white",
        }}
        closable={false}
        modal
        onHide={onHide}
      >
        <InputNumber
          inputStyle={{ textAlign: "center", width: "100%" }}
          value={value}
          onValueChange={(e) => setValue(e.value)}
          mode="decimal"
          minFractionDigits={2}
          locale="pt-BR"
        />
        {error && <span style={{ color: "red" }}>(Valor é obrigatório)</span>}
      </Dialog>
      <Dropdown
        id="payment"
        value={payment?.type}
        options={paymentTypes}
        onChange={(e) => setPayment({ ...payment, type: e.value })}
        placeholder="Selecione a forma de pagamento"
        style={{
          borderRadius: "7px",
          border: "1px solid #656565",
          marginBottom: "10px",
          backgroundColor: "#323232",
          color: "white !important",
        }}
      />
      {opt.cpf && (
        <div>
          <label
            style={{
              color: "#323232",
              alignSelf: "self-start",
              marginBottom: "5px",
              fontWeight: "bold",
            }}
            htmlFor="cpf"
          >
            CPF (Obrigatório para nota fiscal):
          </label>
          <InputMask
            name="cpf"
            value={cpf}
            onChange={onChangeCPF}
            style={{
              borderRadius: "10px",
              backgroundColor: "#323232",
              color: "white",
              width: "100%",
              textAlign: "center",
              fontSize: "1.2rem",
            }}
            mask="999.999.999-99"
            slotChar=" "
            onFocus={(e) => e.target.setSelectionRange(0, 0)}
            placeholder="999.999.999-99"
            showIcon
            inputStyle={{
              fontSize: "2rem",
              borderBottomLeftRadius: "10px",
              borderTopLeftRadius: "10px",
              backgroundColor: "#323232",
              filter: "drop-shadow(1px 1px 4px rgba(0,0,0,0.5))",
              textAlign: "center",
            }}
          ></InputMask>
          {!validarCPF(cpf) && (
            <span
              style={{ color: "red", fontSize: "1rem", fontStyle: "italic" }}
            >
              CPF inválido
            </span>
          )}
        </div>
      )}
      {payment?.type === "Dinheiro" && (
        <ToggleButton
          className="p-shadow-9"
          style={{ ...tStyle, borderRadius: "10px" }}
          checked={troco}
          onLabel={`Preciso de Troco para R$ ${value?.toFixed(2)}`}
          offLabel="Clique aqui se precisa de troco!"
          onChange={onToggle}
        />
      )}
      {payment?.type === "PIX" && opt.pixchave && (
        <div
          style={{
            borderRadius: "10px",
            fontWeight: "bold",
            color: "black",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          Clique em "finalizar pedido" para finalizá-lo e enviar ao
          estabelecimento. Na próxima tela terá a chave para realizar o pix e o
          número para enviar o comprovante
        </div>
      )}
    </div>
  );
};
